// extracted by mini-css-extract-plugin
export default {"logoImg":"VendorApp_logoImg__je3Kp","logoTxt":"VendorApp_logoTxt__qgygb"};